import { RouteRecordRaw } from 'vue-router';
import store from '../store';

const accountRoutes: Array<RouteRecordRaw> = [
    {
        path: '/login',
        name: 'Login',
        meta: {
            title: 'Login',
            description: '',
        },
        component: () => import('@/views/account/loginPage.vue'),
    },
    {
        path: '/signup',
        name: 'Sign up',
        meta: {
            title: 'Sign up',
            description: '',
        },
        component: () => import('@/views/account/signUpPage.vue'),
    },
    {
        path: '/account/deals',
        redirect: '/deals',
    },
    {
        path: '/account/offers',
        redirect: '/deals',
    },
    {
        path: '/offers',
        redirect: '/deals',
    },
    {
        path: '/account/rewards',
        redirect: '/rewards',
    },
    {
        path: '/deals',
        name: 'Deals',
        meta: {
            title: 'Deals',
            description: '',
        },
        component: () => import('@/views/account/dealsPage.vue'),
    },
    {
        path: '/pizza-pals',
        name: 'Pizza Pals',
        component: () => import('@/views/bundle/pizzaPalsPage.vue'),
        beforeEnter: (to, from, next) => {
            const valueBundle = store.getters.getValueBundle;
            const validCoupons = store.getters.getValidCoupons;
            const couponNumber = valueBundle?.coupon_number;
            const hasValueBundleCoupon = !!validCoupons?.find((c) => parseInt(c.code) === parseInt(couponNumber));
            if (!hasValueBundleCoupon) {
                next(`/pizza-pals/${valueBundle.coupon_number}/1`);
            } else {
                next();
            }
        },
    },
    {
        path: '/deals/:couponNumber',
        name: 'Deal Builder',
        meta: {
            title: 'Deal Builder',
            description: '',
            hideTabNavigation: true,
        },
        alias: '/pizza-pals/:couponNumber',
        component: () => import('@/views/bundle/bundlePage.vue'),
    },
    {
        path: '/deals/:couponNumber/:groupNumber',
        name: 'Deal Builder Group',
        meta: {
            title: 'Deal Builder',
            description: '',
            hideTabNavigation: true,
        },
        alias: '/pizza-pals/:couponNumber/:groupNumber',
        component: () => import('@/views/bundle/groupPage.vue'),
    },
    {
        path: '/deals/:couponNumber/:groupNumber/:itemNumber',
        name: 'Deal Builder Item',
        meta: {
            title: 'Deal Builder',
            description: '',
            hideTabNavigation: true,
        },
        alias: '/pizza-pals/:couponNumber/:groupNumber/:itemNumber',
        component: () => import('@/views/bundle/itemPage.vue'),
    },
    {
        path: '/rewards',
        meta: {
            seo: {
                title: 'Donatos Rewards',
                description: 'Points, Perks and Free Pizza! Start earning rewards today. Sign up or log in.',
                keywords: ['Donatos rewards', 'Donatos loyalty program', 'earn rewards Donatos', 'Donatos perks', 'free pizza rewards'],
            },
        },
        component: () => import('@/views/account/rewardsAccountPage.vue'),
    },
    {
        path: '/rewards/history',
        name: 'Rewards History',
        meta: {
            title: 'Rewards History',
        },
        component: () => import('@/views/account/rewardsHistoryPage.vue'),
    },
    {
        path: '/history',
        name: 'history',
        meta: {
            title: 'Account History',
        },
        props: true,
        component: () => import('@/views/account/historyPage.vue'),
    },
    {
        path: '/account',
        name: 'My Account',
        meta: {
            title: 'My Account',
            description: '',
            hideTabNavigation: true,
            backBtn: true,
        },
        component: () => import('@/views/account/accountPage.vue'),
        beforeEnter: (to, from, next) => {
            const isAuthenticated = store.getters.isLoggedIn;
            if (!isAuthenticated) {
                next('/login?redirect=/account');
            } else {
                next();
            }
        },
    },
];

export default accountRoutes;
